/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import { ProtocolSectionArgs } from "../../base-components/base-protocol-item";
export default class TreatmentHistoryDefaultSurgeryComponent extends Component {
  get surgeryTypes() {
    switch (this.args.followUpReasonId) {
      case "onco-lung-cancer":
        return ["pulmonary", "cerebral", "adrenal"];
      case "onco-pancreatic-cancer":
        return ["prostatectomy", "lymph-node-dissection", "pulpectomy", "orchiectomy"];
      default:
        return ["auxiliary-cleaning", "mastectomy", "quadrantectomy", "tumorectomy", "oncoplasty", "pamectomy", "prophylactic-surgery", "enlargement", "reconstruction", "sentinel-node", "pac-installation", "prophylactic-annexectomy", "ambulatory", "hospitalisation", "external", "prostatectomy", "lymph-node-dissection", "pulpectomy", "orchiectomy"];
    }
  }
}